import ServiceNowMapper from "../mappings/service-now-mapper";
import { IConfig } from "../models/config-viewmodel";
import { ISearchResults } from "../models/service-now-model";

class ServiceNowService {
    private mapper = new ServiceNowMapper();

    constructor() {}

    public search(config: IConfig, query: string, HttpService: any): Promise<any> {
        return this.getResponse(this.getUrl(config, query), HttpService);
    }

    private getResponse(url: string, HttpService: any): Promise<any> {
        return new Promise((resolve, reject) => {
            HttpService.getItem(url).then((response: ISearchResults) => {
                resolve(this.mapper.mapSearchResults(response));
            }).catch((error: any) => {
                reject(error)
            });
        });
    }

    private getUrl(config: IConfig, query: string): string {
        return `${config.endpoint ?? ''}/api/employees/search/${config.language}/${query}`;
    }
}

export default new ServiceNowService();